<template>
	<div class="home">
		<div class="aba-content">

			<div class="categories-list" v-if="showCategoriesList">
				<CategoriesList />
			</div>

			<div class="grid"  v-if="aba=='grid'">
				<Grid />
			</div>

			<div v-if="aba=='tasks'">
				<div class="tasks-content">
					<div class="tasks-content-header theme-color-4">
						<div class="aside-content-background theme-bg-4"></div>
						<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 47 47" xml:space="preserve"><g><path d="M6.12,38.52V5.136h26.962v28.037l5.137-4.243V2.568C38.219,1.15,37.07,0,35.652,0h-32.1C2.134,0,0.985,1.15,0.985,2.568 v38.519c0,1.418,1.149,2.568,2.567,2.568h22.408L22.33,38.52H6.12z"/><path d="M45.613,27.609c-0.473-0.446-1.2-0.467-1.698-0.057l-11.778,9.734l-7.849-4.709c-0.521-0.312-1.188-0.219-1.603,0.229 c-0.412,0.444-0.457,1.117-0.106,1.613l8.506,12.037c0.238,0.337,0.625,0.539,1.037,0.543c0.004,0,0.008,0,0.012,0 c0.408,0,0.793-0.193,1.035-0.525l12.6-17.173C46.149,28.78,46.084,28.055,45.613,27.609z"/><path d="M27.306,8.988H11.897c-1.418,0-2.567,1.15-2.567,2.568s1.149,2.568,2.567,2.568h15.408c1.418,0,2.566-1.15,2.566-2.568 S28.724,8.988,27.306,8.988z"/><path d="M27.306,16.691H11.897c-1.418,0-2.567,1.15-2.567,2.568s1.149,2.568,2.567,2.568h15.408c1.418,0,2.566-1.149,2.566-2.568 C29.874,17.841,28.724,16.691,27.306,16.691z"/><path d="M27.306,24.395H11.897c-1.418,0-2.567,1.15-2.567,2.568s1.149,2.568,2.567,2.568h15.408c1.418,0,2.566-1.15,2.566-2.568 C29.874,25.545,28.724,24.395,27.306,24.395z"/></g></svg>
						Minhas tarefas
						<a @click.prevent="formTask">Adicionar</a>
					</div>
					<div class="tasks-content-body">
						<div class="aside-content-background theme-bg-3"></div>
						<Tasks />
					</div>
				</div>
			</div>

			<div v-if="aba=='textlinks'">
				Options
			</div>

			<div v-if="aba=='profile'">


				<div class="profile-menu">

					<figure>
						<img v-if="userAvatar" :src="userAvatar">

						<svg v-if="!userAvatar" class="svgNoAvatar" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" xml:space="preserve">
							<circle cx="12" cy="8" r="5"/>
							<path d="M16.5,12c-1.1,1.3-2.7,2-4.5,2s-3.4-0.8-4.5-2C5.4,13.2,4,15.4,4,18v2.9c2.1,1.9,4.9,3.1,8,3.1s5.9-1.2,8-3.1V18
							C20,15.4,18.6,13.2,16.5,12z"/>
						</svg>

						<svg v-if="userIsAnonymous" class="svgWarning" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg>

						<label>
							<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60 60" xml:space="preserve">
								<g>
									<path d="M30,20.5c-6.617,0-12,5.383-12,12s5.383,12,12,12s12-5.383,12-12S36.617,20.5,30,20.5z"/>
									<path d="M55.201,15.5h-8.524l-4-10H17.323l-4,10H12v-5H6v5H4.799C2.152,15.5,0,17.652,0,20.299v29.368
									C0,52.332,2.168,54.5,4.833,54.5h50.334c2.665,0,4.833-2.168,4.833-4.833V20.299C60,17.652,57.848,15.5,55.201,15.5z M10,15.5H8v-3
									h2V15.5z M30,50.5c-9.925,0-18-8.075-18-18s8.075-18,18-18s18,8.075,18,18S39.925,50.5,30,50.5z M52,27.5c-2.206,0-4-1.794-4-4
									s1.794-4,4-4s4,1.794,4,4S54.206,27.5,52,27.5z"/>
								</g>
							</svg>
							<input type="file" @change="onFileChange">
						</label>

					</figure>

					<p v-if="!userIsAnonymous">{{ userEmail }}</p>

					<p v-if="userIsAnonymous" class="anonymousWarning"><a href="#" @click.prevent="identifyAnonymous">Você ainda não é um usuário registrado. Registre-se aqui para que suas configurações sejam salvas.</a></p>

					<a v-if="userIsAnonymous" class="menu-item" href="#" @click.prevent="identifyAnonymous">Registrar</a>

					<router-link to="meu-perfil" v-if="!userIsAnonymous" class="menu-item">Meu perfil</router-link>

					<a v-if="!userIsAnonymous" class="menu-item" href="#" @click.prevent="logout">Logout </a>


				</div>

			</div>

			<div v-if="aba=='options'">

				<ConfigMobile />

			</div>

		</div>

		<div class="aba-toggles">
			<div>
				<div class="aba-button" @click="toggleCategoriesList()">
					<span class="categories-list-toggle"></span>
				</div>
			</div>
			<div class="aba-new-category">
				<div class="aba-button" @click="newCategory">
					<span>+</span>
				</div>
			</div>
			<div>
				<div class="aba-button" @click="abrirAba('tasks')">
					<span class="ico-tasks" :class="{'ico-tasks-danger':hasTaskOverdue}">
						<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 47 47" xml:space="preserve"><g><path d="M6.12,38.52V5.136h26.962v28.037l5.137-4.243V2.568C38.219,1.15,37.07,0,35.652,0h-32.1C2.134,0,0.985,1.15,0.985,2.568 v38.519c0,1.418,1.149,2.568,2.567,2.568h22.408L22.33,38.52H6.12z"/><path d="M45.613,27.609c-0.473-0.446-1.2-0.467-1.698-0.057l-11.778,9.734l-7.849-4.709c-0.521-0.312-1.188-0.219-1.603,0.229 c-0.412,0.444-0.457,1.117-0.106,1.613l8.506,12.037c0.238,0.337,0.625,0.539,1.037,0.543c0.004,0,0.008,0,0.012,0 c0.408,0,0.793-0.193,1.035-0.525l12.6-17.173C46.149,28.78,46.084,28.055,45.613,27.609z"/><path d="M27.306,8.988H11.897c-1.418,0-2.567,1.15-2.567,2.568s1.149,2.568,2.567,2.568h15.408c1.418,0,2.566-1.15,2.566-2.568 S28.724,8.988,27.306,8.988z"/><path d="M27.306,16.691H11.897c-1.418,0-2.567,1.15-2.567,2.568s1.149,2.568,2.567,2.568h15.408c1.418,0,2.566-1.149,2.566-2.568 C29.874,17.841,28.724,16.691,27.306,16.691z"/><path d="M27.306,24.395H11.897c-1.418,0-2.567,1.15-2.567,2.568s1.149,2.568,2.567,2.568h15.408c1.418,0,2.566-1.15,2.566-2.568 C29.874,25.545,28.724,24.395,27.306,24.395z"/></g></svg>
					</span>
				</div>
			</div>
			<div>
				<div class="aba-button" @click="abrirAba('options')">
					<span class="ico-options">
						<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24" xml:space="preserve"><path d="M23.9,18.8l-7.7-7.3l6.2-6.3l0-0.2c0-1.5-0.3-2.6-1.2-3.2c-1.2-0.8-2.8-0.2-2.9-0.1l-6.1,6L4.9,0.7L0.2,4.9 l7.7,7.3l-4.1,4l-3.1,7.1l7.1-3.2l4.1-4.1l7.6,7.3L23.9,18.8z M17.8,3.7l2.4,2.4l-1.2,1.2L16.6,5L17.8,3.7z M1.6,4.9l3.3-3l1,0.9 L4.2,4.4C4,4.6,3.9,4.9,4.1,5.1c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.2,0,0.3-0.1l1.7-1.5l0.9,0.8L6.6,5.1c-0.2,0.2-0.2,0.5,0,0.7 C6.7,5.8,6.8,5.8,7,5.8c0.1,0,0.2,0,0.3-0.1L8.1,5l0.8,0.8L7.2,7.4C7,7.5,7,7.8,7.2,8c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.2,0,0.3-0.1 l1.7-1.6l0.8,0.7L9.7,7.9c-0.2,0.2-0.2,0.5,0,0.7C9.8,8.6,9.9,8.7,10,8.7c0.1,0,0.3,0,0.4-0.1l0.7-0.7l0.6,0.6l-3.2,3.1L1.6,4.9z M4.3,20.6l-1-1l1-2.4c0.6,0.2,2,0.7,2.5,2.2L4.3,20.6z M5.1,16.4L15.9,5.6l2.5,2.4L7.7,18.8C7.1,17.3,5.9,16.7,5.1,16.4z M12.4,15.4l3.2-3.2l0.5,0.5l-1.5,1.4c-0.2,0.2-0.2,0.5,0,0.7c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1l1.5-1.4l0.7,0.7 l-0.7,0.7c-0.2,0.2-0.2,0.5,0,0.7c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1l0.7-0.7l1,0.9l-1.7,1.5c-0.2,0.2-0.2,0.5,0,0.7 c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.2,0,0.3-0.1l1.7-1.6l0.9,0.8l-0.8,0.8c-0.2,0.2-0.2,0.5,0,0.7c0.1,0.1,0.2,0.1,0.4,0.1 c0.1,0,0.2,0,0.3-0.1l0.8-0.8l1.1,1.1L19.4,22L12.4,15.4z"/></svg>
					</span>
				</div>
			</div>
			<div>
				<div class="aba-button" @click="abrirAba('profile')">
					<span class="ico-profile">
						<img v-if="userAvatar" :src="userAvatar">
						<svg v-if="!userAvatar" class="svgNoAvatar" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" xml:space="preserve">
							<circle cx="12" cy="8" r="5"/>
							<path d="M16.5,12c-1.1,1.3-2.7,2-4.5,2s-3.4-0.8-4.5-2C5.4,13.2,4,15.4,4,18v2.9c2.1,1.9,4.9,3.1,8,3.1s5.9-1.2,8-3.1V18
							C20,15.4,18.6,13.2,16.5,12z"/>
						</svg>
						<svg v-if="userIsAnonymous" class="svgWarning" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg>
					</span>
				</div>
			</div>
		</div>

	</div>

</template>

<style>



</style>
<style scoped>

	.home { padding:0; display: block;}
	.aba-content {
		padding-bottom:52px;
    min-height: calc(100vh - 52px);
	 }
	.aba-toggles{
		position: fixed;
		bottom:0;
		left:0;
		right:0;
		z-index: 10;
		height:52px; display: flex; align-items: center; background:#f2f2f2; box-shadow: 0 -2px 5px rgba(0,0,0,0.2);  }
	.aba-toggles > div { flex:1;  }

	.aba-button {
		position: relative;
		width:45px;
		height:45px;
		margin:0 auto;
	 }


	.categories-list-toggle{ display: block; width:100%; height:100%; background: url(../../public/images/menu-icon.png) no-repeat center ; background-size: 30px; }

	.aba-new-category .aba-button{ padding:8px; }
	.aba-new-category span {font-size: 33px; font-weight: 400; background: #00b3bc; border-radius: 200px; height: 30px; width: 30px; display: block; line-height: 30px; text-align: center; color:#fff;}


	/*.ico-widgets:after { display: block; content:"Wid"; width:40px; height:40px; line-height:40px; text-align: center; font-weight: bold; color:#00b3bc; }*/

	.ico-options { display: block; width:100%; height:100%; padding:7.5px; }
	.ico-options svg { width:100%; height:100%; }
	.ico-options svg path { fill:#00b3bc }

	.ico-tasks {width:100%;height: 100%;display:block; padding:7.5px;}
	.ico-tasks svg { width:100%; height:100%; }
	.ico-tasks svg path { fill:#00b3bc }
  .ico-tasks-danger svg path { fill:#d22626 }


	.ico-profile { display:block; border:2px solid #47cdd1; border-radius: 50px;overflow: hidden; width:40px; height:40px; margin-top:2px;}
	.ico-profile img {width:100%; height:100%; display: block; object-fit: cover;}
	.ico-profile svg.svgNoAvatar { width:100%; height:100%; display: block;}
	.ico-profile svg.svgNoAvatar path { fill:#47cdd1; }
	.ico-profile svg.svgNoAvatar circle { fill:#47cdd1; }

	.ico-profile svg.svgWarning { position: absolute; top: -3px; left: calc(50% + 3px); width:20px; height:20px; }
	.ico-profile svg.svgWarning path { fill:#c00;}

	.profile-menu { text-align:center; margin:20px;padding:20px; background-color:#fff; border-radius:5px; box-shadow: 1px 1px 5px rgba(0,0,0,.5); }
	.profile-menu figure{ position:relative; width:80px; height:80px; border:2px solid #47cdd1; border-radius: 40px; margin: 0 auto 20px; }
	.profile-menu figure img {width:100%; height:100%; display: block; object-fit: cover; border-radius: 80px;}
	.profile-menu figure > svg.svgNoAvatar path { fill:#47cdd1; }
	.profile-menu figure > svg.svgNoAvatar circle { fill:#47cdd1; }
	.profile-menu figure .svgWarning { position: absolute; top:0; right:0; width:30px; height:30px;}
	.profile-menu figure .svgWarning path { fill:#c00;}
	.profile-menu label{ cursor: pointer; position: absolute; bottom:0; right:0; width:30px; height:30px; background-color:#fff; padding:5px; border-radius: 100%; }
	.profile-menu label svg path{ fill:#999; }
	.profile-menu label svg circle { fill:#999; }
	.profile-menu label input { display: none;}
	.profile-menu p { margin-bottom:10px;}
	.profile-menu .menu-item { border:1px solid #dadce0; padding: 10px 24px; display: block; margin:10px 0; color:#333; }


	.categories-list {
		position: fixed;
		bottom: 52px;
		left: 0;
		width: 100%;
		z-index: 3;
  }


.tasks-content { margin:5px; border-radius:8px; box-shadow:0px 0px 5px 3px rgba(0,0,0,0.15); }
.tasks-content-header { position: relative; border-radius:8px 8px 0 0; border-bottom:1px solid rgba(255,255,255,.3); padding:5px 10px; font-size:20px; overflow: hidden;}
.tasks-content-header svg {width:20px;height: 20px;display:inline-block;margin-right: 3px; vertical-align: -3px}
.tasks-content-body { padding:10px; color:#fff; border-radius: 8px; position: relative; overflow: hidden;}
.tasks-content-header + .tasks-content-body { border-radius: 0 0 8px 8px; }
.tasks-content-header a {cursor: pointer; line-height: 20px; font-size: 20px; text-align: center; padding: 0; position: absolute; right: 5px; color: inherit; padding:5px 10px; }

.aside-content-background {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: -1;
}

/*
.profile-menu { position: absolute; top:100%; top:calc(100% + 10px); right:0; padding:20px; background-color: #fff; box-shadow: 1px 1px 5px rgba(0,0,0,.5); border-radius: 5px;text-align:center; min-width:300px; }
.profile-menu figure{ position:relative; width:80px; height:80px; border:2px solid #47cdd1; border-radius: 40px; margin: 0 auto 20px; }
.profile-menu figure img {width:100%; height:100%; display: block; object-fit: cover; border-radius: 80px;}
.profile-menu figure > svg path { fill:#47cdd1; }
.profile-menu figure > svg circle { fill:#47cdd1; }
.profile-menu label{ cursor: pointer; position: absolute; bottom:0; right:0; width:30px; height:30px; background-color:#fff; padding:5px; border-radius: 100%; }
.profile-menu label svg path{ fill:#999; }
.profile-menu label svg circle { fill:#999; }
.profile-menu label input { display: none;}
.profile-menu p { margin-bottom:10px;}
.profile-menu .menu-item { border:1px solid #dadce0; padding: 10px 24px; display: inline-block; margin:10px 0; color:#333; }
*/

</style>

<script>

	// import Widgets from '@/components/Widgets.vue';
	//import Clock from '@/components/Clock.vue';
	//import Sugeridos from '@/components/Sugeridos.vue';
	import CategoriesList from '@/components/CategoriesList.vue';
	import ConfigMobile from '@/components/ConfigMobile.vue';
	import Tasks from '@/components/Tasks.vue';
	//import Textlinks from '@/components/Textlinks.vue';
	import Grid from '@/components/Grid.vue';



	export default {
		name: 'home',
		components: {
			// Widgets,
			//Clock,
			//Sugeridos,
			CategoriesList,
			ConfigMobile,
			Tasks,
			//Textlinks,
			Grid,
		},
		data() {
			return {
				aba:'grid',
				showSurveyButton:true,
				showCategoriesList:false,
			}
		},
		computed: {

			config(){
				return this.$store.state.config;
			},
			preferences(){
				return this.$store.getters.preferences;
			},

			user() {
				return this.$store.getters.user;
			},
			userId() {
				return this.$store.getters.userId;
			},
			hasTaskOverdue(){
				for(var i in this.$store.state.tasks.tasks){
          if(this.$store.state.tasks.tasks[i].overdue && !this.$store.state.tasks.tasks[i].done)
						return true;
				}
				return false;
			},
      userEmail(){
        return this.$store.getters.user.email
      },
      userAvatar(){
        return this.$store.getters.preferences.avatar;
      },
      userIsAnonymous(){
        return this.$store.state.user.isAnonymous==true
      },

		},
		methods:{
			identifyAnonymous(){
				this.$store.dispatch('anonymousRedirectLogin');
			},
			abrirAba(aba){
				if(this.aba=='options'){
					if(askRegisterAnonymous(this.$store.state)) {
						this.$router.push({name:'formRegistrar'});
					}

				}
				this.aba = aba;
				window.scrollTo(0,0);
			},
			toggleCategoriesList(){
				if(this.aba!='grid') return this.abrirAba('grid');
				this.showCategoriesList = !this.showCategoriesList;
			},
			logout() {
				this.$store.dispatch('userSignOut');
			},
			formAnuncie(){
				this.$router.push({name:'formAnuncie'})
			},
			formTask(){
				this.$router.push({name:'formTask'})
			},
			newCategory(){
				this.$router.push({name:'formNewCategory' })
			},
			newTextlink(){
				this.$router.push({name:'formTextlink'})
			},

			hideSurvey(){
				this.showSurveyButton = false;
				this.db.collection('users').doc(this.userId).update({showSurveyButton:false});
			},
			modalAdicionarSiteInicio(){
				this.$router.push({name:'site-inicio'})
			},


      onFileChange(e){
        var files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;
        var file = files[0];
        console.log(file);
        var reader = new FileReader();
        var img = new Image();
        reader.onload = (re) => {

          console.log('reader load');
          img.onload = (ie) => {
            console.log('img load');

            var MAX_WIDTH = 800;
            var MAX_HEIGHT = 800;
            var width = img.width;
            var height = img.height;

            if (width > height) {
              if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width;
                width = MAX_WIDTH;
              }
            } else {
              if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height;
                height = MAX_HEIGHT;
              }
            }

            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext("2d");

            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);
            var dataurl = canvas.toDataURL("image/jpeg");

            this.$store.dispatch('setAvatar',{image:dataurl});

          }
          img.src = re.target.result;
        }
        reader.readAsDataURL(file);
      },

		},

		created() {


			if(this.user.showSurveyButton===false){
				this.showSurveyButton = false;
			}

			if(!this.user.skipSiteInicio && this.user.created_at && this.user.created_at < new Date().getTime() - 1000*60*60*24){
				this.modalAdicionarSiteInicio();
			}


		},

	};





</script>